import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { caseStudies } from '../caseStudies';

const CaseStudies = () => {
  return (
    <div id="case-studies" className="hidden mt-28 md:mt-40 pt-16 border-t border-[var(--border)] scroll-mt-24" data-testid="case-studies">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <div>
          <Reveal><p className="label mb-4 !text-[var(--accent)]">SELECTED WORK</p></Reveal>
          <Reveal delay={80}>
            <h3 className="font-display font-medium text-[clamp(1.8rem,4vw,3.2rem)] leading-[1.05] tracking-[-0.02em] max-w-[60ch]">
              A few of the experiences <br className="hidden sm:block" /><span className="font-serif-c italic text-[var(--accent)] font-normal">we engineered.</span>
            </h3>
          </Reveal>
        </div>
        <Reveal delay={120} className="md:ml-auto">
          <p className="text-[var(--muted)]  font-light max-w-[34ch] md:text-right md:ml-auto">
            Each one began as a single conversation and ended as something people could walk into. Open any to read the story.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {caseStudies.map((c, i) => (
          <Reveal key={c.slug} delay={(i % 2) * 80}>
            <Link
              to={`/work/${c.slug}`}
              data-testid={`case-card-${c.slug}`}
              className="group block relative rounded-2xl overflow-hidden border border-[var(--border)] hover:border-[var(--accent)]/50 transition-colors duration-500"
            >
              <div className="aspect-[16/10] overflow-hidden bg-[var(--surface)]">
                <img
                  src={c.cover}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover scale-105 grayscale group-hover:grayscale-0 group-hover:scale-100 transition-[transform,filter] duration-[1400ms] ease-out"
                />
              </div>
              {/* colour overlay - fades out on hover to reveal full colour */}
              <div className="pointer-events-none absolute inset-0 bg-[var(--brand-blue)]/45 mix-blend-multiply opacity-100 group-hover:opacity-0 transition-opacity duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D17] via-[#0A0D17]/20 to-transparent" />
              {/* corner brackets */}
              <span className="pointer-events-none absolute top-4 left-4 w-4 h-4 border-l border-t border-[var(--accent)]/60" />
              <span className="pointer-events-none absolute bottom-4 right-4 w-4 h-4 border-r border-b border-[var(--accent)]/60" />

              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-between">
                <div className="flex items-center justify-between">
                  <span className="label  !text-white/80 border border-white/20 px-3 py-1 rounded-full backdrop-blur-sm">{c.category}</span>
                  <span className="font-mono text-[10px] tracking-[0.15em] text-white/60">{c.year}</span>
                </div>
                <div>
                  <div className="flex items-end justify-between gap-4">
                    <div>
                      <p className="label  !text-[var(--accent)] mb-2">{c.client}</p>
                      <h4 className="font-display font-medium text-[clamp(1.4rem,3vw,2.4rem)] leading-[1.05] tracking-[-0.01em] text-white">{c.title}</h4>
                    </div>
                    <span className="w-11 h-11 rounded-full bg-[var(--accent)] flex items-center justify-center shrink-0 translate-y-1 opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300">
                      <ArrowRight size={18} className="text-[#0A0D17]" />
                    </span>
                  </div>
                  <p className="text-white/75   font-light mt-4 max-w-[52ch] leading-relaxed">{c.tagline}</p>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default CaseStudies;
